import {
  get,
  post,
  ajax,
  requestDetailById
} from "@/utils/request";

// 登录校验接口

export const loginVerify = params => post(`/user-auth-server/api/user/auth/verify`,params)

// 课程详情
export const Coursedetails = (Id,trainingConfigId) => ajax({url: `/training-server/halfapi/training/course/detail/${Id}/${trainingConfigId}`,methods: 'get',notice: false})
// 章节列表
export const Chapterlist = params => ajax({url: `/training-server/halfapi/training/chapter/list/`,params})
// export const Chapterlist = params => ajax({url: `/training-server/api/course/chapter/list`,params})
// export const Chapterlist = params => post(`/training-server/api/course/training/chapter/list`,params)
// 获取章节进度
export const getChapterSpeed = params => ajax({url: `/training-server/api/course/h5/chapterLearnProgress`,params,methods: 'get'})
// 返回章节进度
export const setChapterSpeed = params => ajax({url: `/training-server/api/course/h5/closeVideoBack`,params,methods: 'get'})
// 章节详情
export const Chapterdetails = (courseld,chapterId,trainingConfigId) => requestDetailById(`/training-server/halfapi/training/chapter/detail/${courseld}/${chapterId}/${trainingConfigId}`)
// 已购章节列表
export const getBoughtList = params => ajax({url: `/training-server/api/course/h5/chapter/boughtList`,params})
// 微信支付
export const weixinPay = params => ajax({url: `/training-server/api/order/h5/wechat/create`,params})
// 支付宝支付
export const zfbPay = params => ajax({url: `/training-server/api/order/h5/alipay/create`,params})
// 余额支付
export const balancePay = params => ajax({url: '/training-server/api/order/h5/balance/create',params})
// 下单前校验
export const validateOrder = params => ajax({url: `/training-server/api/order/h5/create/verify`,params})

// 我的课程
export const boughtList = parmas => post(`/training-server/api/course/h5/boughtList`, parmas);

//订单列表
export const orderList = parmas => get(`/training-server/api/order/h5/order/list/${parmas.pageNumber}/${parmas.pageSize}/${parmas.trainingConfigId}` );
//培训平台详情
export const homeDetail = parmas => get(`/training-server/halfapi/training/config/detail/`+parmas);
//培训首页详情
export const homeContent = parmas => get(`/training-server/openapi/training/index`); 

// 分享列表
export const Share = parmas => post(`/sys-server/open-api/h5/share`, parmas);
const requestByPost = (url,params) => ajax({url,methods: 'post',params})
// 获取微信JS config参数-服务号分享
export const wxTicket_config = params => requestByPost(`/sys-server/open-api/h5/ticket_config`,params)
// 我的账户
// 我的账户--账户余额
// export const userBalance = parmas => ajax({url: `/training-server/api/account/h5/user/account`, parmas,methods: 'get'});
// 我的账户 -- 账户详情
export const accountCostrecord = params =>  ajax({url: `/training-server/api/account/h5/user/account/log`, params,methods: 'post'})
// 我的账户 -- 在线充值
export const payOnline = params => ajax({url: `/training-server/api/account/h5/balance/recharge/pay`,params,methods: 'post'})
// 我的账户 -- 充值卡充值
export const payByCard = params => ajax({url: `/training-server/api/account/h5/card/exchange`,params,methods: 'post'})

// 用户余额
export const userAccount = parmas => get(`/training-server/api/account/h5/user/account`,parmas);
 
// 充值卡充值&课程卡充值
export const Exchange = parmas => post(`/training-server/api/account/h5/card/exchange`, parmas);
// 兑换记录
export const exchangeLog = parmas => post(`/training-server/api/account/h5/user/exchange/log`,parmas);

//登录后查询用户信息
export const userDetail = parmas => get(`/sys-server/api/sys/user/detail`);

//登录后查询用户信息
export const basicRegist = parmas => post(`/sys-server/api/h5_resume/basic/regist`,parmas);

// 培训专区有权限私密id列表
export const platformList = () => ajax({url: `/training-server/halfapi/user/platform_list`,methods: 'get'})

// 优惠券兑换接口
export const cardOtherExchange = parmas => get(`/training-server/api/account/h5/cardOther/exchange`, parmas);
// 免费学习
export const Freestudy = parmas => get(`/training-server/api/course/h5/free_study`, parmas);
// 获取用户unionid
export const extUnionid= parmas => get(`/user-auth-server/api/user/auth/ext/`+ parmas);

// 用户的专区列表
export const userplatformList= parmas => get(`/training-server/api/h5/training/platform/list`);

// 新 卡片激活
export const cardactive = parmas => get(`/training-server/api/h5/card/active`, parmas);
// 证书列表
export const getCertificate = parmas => get(`/training-server/api/h5/training/graduation/certs`, parmas);
// 培训专区有权限私密id列表
export const getLearnProgress = parmas => ajax({url: `/training-server/openapi/specialRemindData/${parmas}`,methods: 'get'})
//通用数据埋点
export const commonBuriedPoint = params => ajax({url: `/sys-server/open-api/h5/commonBuriedPoint`,methods: 'post',params,field: 'params',notice: false})
// 是否关注公众号
export const isSubscribe =  () => ajax({url: `/user-auth-server/api/user/auth/is_subscribe`,methods: 'get'})
//获取激活卡姓名
export const userCheck =  () => ajax({url: `/training-server/api/h5/training/user/check`,methods: 'get'})
// 退出登录
export const webRemoveToken = id => get(`/user-auth-server/api/user/auth/web_remove_token/${id}`);
// 获取专区详情
export const cardDetail =   params => ajax({url: `/training-server/api/h5/card/detail`,params,methods: 'get'})



// WEBPACK FOOTER //
// ./src/api/getData.js